import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { CONFIGURABLE_IMAGES, CURRENCY_LABEL, DEFAULT_PRECISION, REG_EX, StorageHelper, Utils } from '@app/_helpers';
import { ConfigurationService, NgxToastrService, PortfolioService, StrategiesService, SubjectType } from '@app/_shared/providers';
import { AlgowisePositionDataService } from '@app/_shared/providers/algowise-position-data/algowise-position-data.service';
import { MIXPANEL_EVENTS } from '@app/_shared/providers/mixpanel/mixpanel.events';
import { MixpanelService } from '@app/_shared/providers/mixpanel/mixpanel.service';
import {
    BILLING_PORTAL_ERROR,
    LOADING_MESSAGE,
    PAUSE_ALL_CARRYFORWARD_OR_LOGOUT, PAUSE_CARRYFORWARD_ON_LOGOUT, PLANS_DIALOG_TITLE, TERMINATE_ALL_CARRYFORWARD_OR_LOGOUT, TERMINATE_ALL_INTRADAY_OR_LOGOUT, TERMINATE_ALL_ON_LOGOUT,
    TERMINATE_ALL_STRATEGIES_OR_LOGOUT,
    TERMINATE_CARRYFORWARD_ON_LOGOUT, TERMINATE_INTRADAY_AND_PAUSE_CF, TERMINATE_INTRADAY_AND_PAUSE_CF_OR_LOGOUT, TERMINATE_INTRADAY_ON_LOGOUT
} from '@app/_shared/strings';
import { HelpConfig, VerifyDialogData } from '@app/app.interface';
import { VerifyDialogCloseReason } from '@app/app.structs';
import { AuthRole, AuthService } from '@app/modules/auth';
import { NetProfitResponse } from '@app/modules/trading/modules/dashboard/components/margin-summary/margin-summary.interfaces';
import { MarginSummaryService } from '@app/modules/trading/modules/dashboard/components/margin-summary/providers/margin-summary.service';
import { ManageBrokersTab } from '@app/modules/trading/modules/manage-brokers/manage-broker.enums';
import { ConnectedBroker, ConnectedBrokersResponse } from '@app/modules/trading/modules/manage-brokers/manage-broker.interface';
import { ManageBrokerService } from '@app/modules/trading/modules/manage-brokers/manage-broker.service';
import { BriefPortfolioRequest } from '@app/modules/trading/modules/market-place/providers/market-place/market-place.interface';
import { MarketPlaceService } from '@app/modules/trading/modules/market-place/providers/market-place/market-place.service';
import { UserDetails, WalletBalanceData } from '@app/modules/trading/modules/mb-plans/providers/mb-plans.interface';
import { MbPlansService } from '@app/modules/trading/modules/mb-plans/providers/mb-plans.service';
import { finalize } from 'rxjs/operators';
import { MyStrategyType } from '@app/modules/trading/modules/my-strategies/my-strategies.consts';
import { LoginSource } from '@app/modules/trading/modules/profile/components/personal-details/interfaces/personal-details.enum';
import { Subscription } from 'rxjs';
import { ConfirmationDialogService } from '../confirmation-dialog';
import { PanicControlComponent } from '../panic-control/panic-control.component';
import { PortfolioProductType } from '../portfolio-form/portfolio.enums';
import { VerifyDialogComponent } from '../verify-dialog/verify-dialog.component';
import { MbPlansComponent } from '@app/modules/trading/modules/mb-plans/mb-plans.component';
import { ChatService } from '@app/modules/trading/modules/create-with-ai/providers/chat.service';
import { BILLING_PORTAL_ROUTES } from '@app/modules/trading/modules/mb-plans/providers/mb-plans.constants';
import { PlanSubscription } from '@app/modules/trading/modules/profile/components/plans/plans.enums';
import { BooksSocketService } from '@app/_shared/providers/websocket/books-socket/books-socket.service';


@Component({
    selector: 'app-profile-menu',
    templateUrl: './profile-menu.component.html',
    styleUrls: ['./profile-menu.component.scss']
})
export class ProfileMenuComponent implements OnInit, OnDestroy {
    readonly AuthRole = AuthRole;
    CURRENCY_LABEL = CURRENCY_LABEL;
    totalProfit = 0;
    cumulativePnL = 0;
    activeStrategyCount = 0;
    userName: String;
    private subscriptions = new Subscription();
    LoginSource = LoginSource;
    isVendorLogin: boolean;
    DEFAULT_PRECISION = DEFAULT_PRECISION;
    newAccountLink: string;
    isSwastikaLogin: boolean;
    isMasterTrustLogin: boolean;
    isShareIndiaLogin: boolean;
    // showPlanExtendedOffer: boolean = false;

    socialLoginLink: string = '';
    userNameDisplay: string;
    personalDetailsObj: UserDetails;
    isOperatorLogin: boolean = false;
    isAdmin: boolean = false;
    connectedBrokers: ConnectedBroker[] = [];
    // hidePlans: boolean = false;
    isFixedAiOpened: boolean;

    plansEnabled: boolean = false;
    billingRoutes = BILLING_PORTAL_ROUTES;

    walletBalance: WalletBalanceData;
    walletBalanceLoading = false;
    billingPortalLoading: BILLING_PORTAL_ROUTES | null = null;
    isSubscriptionCancelled: boolean = false;
    isFreePlan: boolean = false;
    crownIcon: string = CONFIGURABLE_IMAGES.crownIcon;
    multiBrokerAllowed: boolean = false;
    helpConfig: HelpConfig;

    constructor(
        private router: Router,
        private netUserMarginService: MarginSummaryService,
        private confirmationService: ConfirmationDialogService,
        public authService: AuthService,
        private strategyService: StrategiesService,
        @Inject(MAT_DIALOG_DATA)
        public data,
        private matDialogRef: MatDialogRef<ProfileMenuComponent>,
        private panicDialogRef: MatDialogRef<PanicControlComponent>,
        private matDialog: MatDialog,
        private portfolioService: PortfolioService,
        private algoService: AlgowisePositionDataService,
        private configurationServie: ConfigurationService,
        private toastr: NgxToastrService,
        private marketPlaceService: MarketPlaceService,
        private mixpanel: MixpanelService,
        private manageBrokerService: ManageBrokerService,
        private mbPlansService: MbPlansService,
        private chatService: ChatService,
        private booksSocketService: BooksSocketService,
    ) {
        this.isSwastikaLogin = this.authService.isSwastikaLogin;
        this.isMasterTrustLogin = this.authService.isMasterTrustLogin;
        this.isShareIndiaLogin = this.authService.isShareIndiaLogin;
        this.isAdmin = this.authService.accessTokenObj?.role === AuthRole.ADMIN;
        // this.hidePlans = this.configurationServie.remoteConfigCacheObj?.PLANS_CONFIG?.disablePlans;
        this.plansEnabled = this.configurationServie.remoteConfigCacheObj?.PLANS_ENABLED;
        this.isFixedAiOpened = this.chatService.fixedAiOpened;
        this.walletBalance = this.mbPlansService.walletBalance;
        this.multiBrokerAllowed = this.configurationServie.remoteConfigCacheObj?.MULTI_BROKER_ALLOWED ?? true;
        this.helpConfig = this.configurationServie.remoteConfigCacheObj?.HELP_OPTIONS ?? null;


        if (!this.isAdmin) {
            this.mbPlansService.getUserDetails().subscribe(info => {
                this.personalDetailsObj = info;
                this.userName = info.displayName;
                if (info.full_name && info.full_name.length > 0 && info.full_name.length <= 20) {
                    this.userNameDisplay = info.full_name;
                } else {
                    const firstName = info.full_name.split(' ')[0];
                    this.userNameDisplay = firstName && firstName.length > 0 ? firstName : "Guest User";
                }
            })

            this.mbPlansService.getCurrentPlan().subscribe((res) => {
                this.isSubscriptionCancelled = res.subscription_status === PlanSubscription.CANCELLED;
                this.isFreePlan = res.plan.is_default_plan ?? false;
            })
        } else {
            this.userName = "Admin";
            this.userNameDisplay = "Admin";
        }

        this.router.events.subscribe((val) => {
            this.matDialogRef.close();
        })
    }

    ngOnInit(): void {
        if (StorageHelper.operatorToken) {
            this.isOperatorLogin = true;
        }
        if (this.authService.accessTokenObj.role == AuthRole.USER) {
            this.isVendorLogin = this.authService.isVendorLogin;
            this.getActiveAlgoCount();

            this.netUserMarginService.getNetUserProfit().subscribe((res: NetProfitResponse) => {
                this.cumulativePnL = res.net_user_profit.map(item => item.earnings).reduce((a, b) => a + b, 0);
            });

            this.strategyService.strategyListUpdated.subscribe(() => {
                this.getActiveAlgoCount();
            })

            this.recalculateTodaysProfit();

            this.subscriptions.add(
                this.algoService.strategyPositionUpdate.subscribe(() => {
                    this.recalculateTodaysProfit();
                })
            );

            this.loadWalletBalance();
        }
        this.getConnectedBrokers();
        this.subscriptions.add(
            this.booksSocketService.getSubject(SubjectType.BROKER_CONNECTION_SNAPSHOT).subscribe((res: ConnectedBrokersResponse | null) => {
                this.manageBrokerService.cachedConnectedBrokers = res;
                this.getConnectedBrokers();
            })
        )
    }

    getConnectedBrokers() {
        this.manageBrokerService.getConnectedBrokers().subscribe((res: ConnectedBrokersResponse) => {
            this.connectedBrokers = res.data;
        });
    }

    recalculateTodaysProfit() {
        this.algoService.portfoiloStrategyLegPosition.forEach(el => {
            el.forEach(val => {
                val.forEach(ele => {
                    this.totalProfit += ele.bookedPL;
                })

            })
        })
    }

    getActiveAlgoCount() {
        this.marketPlaceService.getPortfoliosByType(MyStrategyType.Deployed, { page_number: 0, page_size: 0 }).subscribe((data) => {
            this.activeStrategyCount = data.data.filter((res) => {
                return res.deployed
            }).length;
        })
    }

    /**
     * Connects the broker by retrieving the server configuration, generating an authentication link,
     * and redirecting the user to the broker's signup URL with the referral code and user name.
     */
    connectBroker() {
        if (this.connectedBrokers.length > 0) {
            this.router.navigateByUrl(`/trading/manage-brokers?selectedTab=${ManageBrokersTab.CONNECTED}`);
        } else {
            this.router.navigateByUrl('/trading/manage-brokers');
        }
        this.mixpanel.track(MIXPANEL_EVENTS.MANAGE_BROKERS, {
            from: 'Profile Menu'
        });
    }

    navigateToGlobalExitSettings() {
        this.router.navigate(["/trading/strategies/global-exit-settings"]);
        this.mixpanel.track(MIXPANEL_EVENTS.PROFILE_GLOBAL_EXIT_PARAMS);
    }

    switchAccounts() {
        this.connectBroker();
    }

    openReports() {
        const userAgent = navigator.userAgent;
        this.configurationServie.getServerConfig().subscribe(res => {
            if (res && res.share_india_domain) {
                let url = res.share_india_domain + '/dashboard/reports';
                // If it's mobile device pass mobile app url
                if (REG_EX.isMobileDevice.test(userAgent)) {
                    url = res.share_india_domain + '/reports';
                }
                window.open(url, '_blank');
            } else {
                this.toastr.simpleCustomToaster('Share India domain not found');
            }
        })
    }

    openPricingDialog() {
        this.matDialog.open(MbPlansComponent, {
            panelClass: ['dialog-no-padding-rounded'],
            data: {
                title: PLANS_DIALOG_TITLE
            },
            width: '90%'
        })
        this.mixpanel.track(MIXPANEL_EVENTS.UPGRADE_PLAN);
    }

    navigateToMyProfile() {
        this.router.navigate(["/trading/profile"]);
        this.mixpanel.track(MIXPANEL_EVENTS.MY_PROFILE);
    }

    openNeedHelp() {
        this.router.navigate(["/trading/profile/help"]);
        this.mixpanel.track(MIXPANEL_EVENTS.OPEN_HELP, { from: 'Profile Menu' });
    }

    panicControl() {
        this.matDialogRef.close();
        this.panicDialogRef = this.matDialog.open(PanicControlComponent, {
            width: '620px',
            height: '300px',
            panelClass: 'panic-control-panel'
        });
    }

    logout() {
        this.matDialogRef.close();
        // Handle for Guest Login or Admin Login
        if (!this.authService.isVendorLogin || this.isAdmin) {
            this.logoutPopup(false, false, false, false);
            return;
        }
        // Check for last session
        this.authService.checkLastSession().subscribe((response) => {
            const isLastSession = response;
            const request: BriefPortfolioRequest = {
                page_number: 0,
                page_size: 0
            }
            this.portfolioService.totalActivePortfoliosCount = 0;
            // Fetch total Active Portfolios
            this.marketPlaceService.getPortfoliosByType(MyStrategyType.Deployed, request).subscribe((data) => {
                // initialized variables to check if deployed portfolios contains,
                // intraday strategy, carryforward strategy with today expiry or running carryforward strategy with future expiry.
                let intradayStrategy: boolean = false;
                let cfStrategyWithTodayExpiry: boolean = false;
                let cfStrategyWithFutureExpiryRunning: boolean = false;
                let activePortfolioCount: number = 0;

                data.data.forEach((portfolio) => {
                    // check if portfolio is deployed
                    if (portfolio.deployed) {
                        // check if it is in running state or in paused state.
                        if (!portfolio.paused) {
                            // if portfolio is in running state then increse the active portfolio count.
                            activePortfolioCount++;

                            // check if portfolio is of CF type
                            if (portfolio.productTypes.includes(PortfolioProductType.CARRYFORWARD)) {
                                // check if cfStartegyWithFutureExpiryRunning or cfStrategyWithTodayExpiry is not set, and portfolio contains endTime.
                                // enable cfStartegyWithFutureExpiryRunning or cfStrategyWithTodayExpiry according to portfolio end time.
                                if ((!cfStrategyWithFutureExpiryRunning || !cfStrategyWithTodayExpiry) && portfolio.runningPortfolioEndTime) {
                                    let today = Utils.getCurrentDateOnly();
                                    let exitDay = Utils.getDateOnlyFromEpoch(portfolio.runningPortfolioEndTime);
                                    if (today === exitDay) {
                                        cfStrategyWithTodayExpiry = true;
                                    } else {
                                        cfStrategyWithFutureExpiryRunning = true;
                                    }
                                }
                            }
                            else {
                                intradayStrategy = true;
                            }
                        }
                        // if the portfolio is in paused state then we need to check if the portfolio is of CF type and it does contain end Time.
                        // increase active portfolio count only if the paused portfolio endTime is of today.
                        else if (portfolio.productTypes.includes(PortfolioProductType.CARRYFORWARD) && portfolio.runningPortfolioEndTime) {
                            let today = Utils.getCurrentDateOnly();
                            let exitDay = Utils.getDateOnlyFromEpoch(portfolio.runningPortfolioEndTime);
                            if (today === exitDay) {
                                cfStrategyWithTodayExpiry = true;
                                activePortfolioCount++;
                            };
                        }
                        // if the portfolio is in paused state and is not of CF type, then it will be of intraday type.
                        // in that case we just need to increase  active portfolio count and enable intradayStrategy; 
                        else {
                            intradayStrategy = true;
                            activePortfolioCount++;
                        }
                    }
                });

                // need to set totalActivePortfoliosCount in portfolioService, as we need check the number of socket message we are going to receive for terminating and pausing portfolios.
                this.portfolioService.totalActivePortfoliosCount = activePortfolioCount;

                this.logoutPopup(isLastSession, intradayStrategy, cfStrategyWithTodayExpiry, cfStrategyWithFutureExpiryRunning);
            });
        });
    }

    terminateOrLogout(toTerminate: boolean) {
        if (toTerminate) {
            this.portfolioService.countTerminatedPortfolios = true;
            this.openLoadingDialogue(LOADING_MESSAGE, this.socialLoginLink);
            // Terminate All running strategies
            this.portfolioService.stopAllPortfolios(undefined, true, true).subscribe();
            this.mixpanel.track(MIXPANEL_EVENTS.PROFILE_LOGOUT);
        } else {
            this.mixpanel.track(MIXPANEL_EVENTS.PROFILE_LOGOUT);
            return this.authService.logoutApi(this.socialLoginLink);
        }
    }


    logoutPopup(isLastSession: boolean, intradayStrategy: boolean, cfStrategyWithTodayExpiry: boolean, cfStrategyWithFutureExpiryRunning: boolean) {
        let btn1Text = "Terminate and Logout";
        let btn2Text = isLastSession ? "Cancel" : "Logout";
        let text2 = '';

        if (intradayStrategy && cfStrategyWithTodayExpiry && !cfStrategyWithFutureExpiryRunning) {
            text2 = isLastSession ? TERMINATE_ALL_ON_LOGOUT : TERMINATE_ALL_STRATEGIES_OR_LOGOUT;
        } else if (intradayStrategy && cfStrategyWithFutureExpiryRunning) {
            text2 = isLastSession ? TERMINATE_INTRADAY_AND_PAUSE_CF : TERMINATE_INTRADAY_AND_PAUSE_CF_OR_LOGOUT;
        } else if (intradayStrategy) {
            text2 = isLastSession ? TERMINATE_INTRADAY_ON_LOGOUT : TERMINATE_ALL_INTRADAY_OR_LOGOUT;
        } else if (cfStrategyWithTodayExpiry) {
            text2 = isLastSession ? TERMINATE_CARRYFORWARD_ON_LOGOUT : TERMINATE_ALL_CARRYFORWARD_OR_LOGOUT;
        } else if (cfStrategyWithFutureExpiryRunning) {
            btn1Text = "Pause and Logout";
            text2 = isLastSession ? PAUSE_CARRYFORWARD_ON_LOGOUT : PAUSE_ALL_CARRYFORWARD_OR_LOGOUT;
        } else {
            btn1Text = "Logout";
            btn2Text = "Cancel";
        }

        const data: VerifyDialogData = {
            heading: "Log Out",
            image: CONFIGURABLE_IMAGES.logoutIcon,
            text1: "Are You Sure You Want to Logout?",
            text2,
            btn1Text,
            btn2Text,
            enableClose: true,
            isBtnAccent: false
        }

        this.matDialog.open(VerifyDialogComponent, {
            width: '360px',
            height: '420px',
            disableClose: true,
            panelClass: ['extend-free-plan-dialog'],
            autoFocus: false,
            data
        }).afterClosed().subscribe((closeReason: VerifyDialogCloseReason) => {
            if (!intradayStrategy && !cfStrategyWithTodayExpiry && !cfStrategyWithFutureExpiryRunning) {
                if (closeReason === VerifyDialogCloseReason.primaryAction) {
                    this.terminateOrLogout(false);
                }
            } else {
                if (closeReason === VerifyDialogCloseReason.primaryAction) {
                    this.terminateOrLogout(true);
                } else if (closeReason === VerifyDialogCloseReason.secondaryAction && !isLastSession) {
                    this.terminateOrLogout(false);
                }
            }
        })
    }

    openLoadingDialogue(loadingMessage: string, socialLoginLink?: string) {
        let data = {
            socialLoginLink
        };
        this.confirmationService.alert({
            message: loadingMessage,
            enableSpin: true
        }, {
            data,
            disableClose: true,
        });
    }

    /**
   * Opens the create new account page.
   * Retrieves the user's username from the access token and generates an authentication link with a referral code.
   * Opens the authentication link in a new window.
   */
    openCreateNewAccount() {
        const userName = this.authService.accessTokenObj?.clientId;
        this.configurationServie.getServerConfig().subscribe((res) => {
            const code = Utils.searchQueryParam(res.config_params.SIGNUP_URL, 'referral');
            const authLink = Utils.addParamToStringUrl(res.config_params.SIGNUP_URL, 'referral', `${code}-${userName}`);
            window.open(authLink);
        })
    }

    openBillingPortal(target: BILLING_PORTAL_ROUTES) {
        if (this.billingPortalLoading === target) return;
        this.billingPortalLoading = target;
        this.mbPlansService.getSignedRedirectUrl(target).pipe(
            finalize(() => { this.billingPortalLoading = null; })
        ).subscribe((res) => {
            if (res.success && res.data?.signed_url) {
                Utils.navigateToUrl(res.data.signed_url);
            } else {
                this.toastr.simpleCustomToaster(BILLING_PORTAL_ERROR, false);
            }
        });
    }

    loadWalletBalance(): void {
        this.walletBalanceLoading = true;
        this.mbPlansService.getWalletBalance().pipe(
            finalize(() => { this.walletBalanceLoading = false; })
        ).subscribe({
            next: (res) => {
                if (res.success && res.data) {
                    this.mbPlansService.walletBalance = res.data;
                    this.walletBalance = res.data;
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
